import { render, staticRenderFns } from "./IconChips.vue?vue&type=template&id=c55bf83c&scoped=true&"
import script from "./IconChips.vue?vue&type=script&lang=js&"
export * from "./IconChips.vue?vue&type=script&lang=js&"
import style0 from "./IconChips.vue?vue&type=style&index=0&id=c55bf83c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55bf83c",
  null
  
)

export default component.exports